import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { LimitDataProvider } from "../../data-provider/limit.dp";
import { UserDataProvider } from "../../data-provider/user.dp";
import { Campaign } from "../../models/campaign.model";
import { Limit } from "../../models/limit.model";
import { PermissionCheck } from "../../shared/permission";

let LimitInfo = {
    selector: "vcLimitInfo",
    templateUrl: "/angular/components/limit/limit-info.component.html",
    bindings: {
        user: "=",
    },
    controller: class LimitInfoController {
        // * bindings for typescript compiler *
        public user: any;
        // ************************************

        public limits: Limit;
        public usersCount: any;
        public permissionProvider: PermissionCheck;
        public activeCampaign: Campaign;

        constructor(
            UserDataProvider: UserDataProvider,
            LimitDataProvider: LimitDataProvider,
            PermissionCheck: PermissionCheck,
            CampaignDataProvider: CampaignDataProvider
        ) {
            this.permissionProvider = PermissionCheck;

            UserDataProvider.getUsersCount().then(
                (count: object) => (this.usersCount = count)
            );

            LimitDataProvider.get().then((limits: Limit) => {
                this.limits = limits;
            });

            this.permissionProvider = PermissionCheck;
            this.activeCampaign = CampaignDataProvider.getActiveCampaign();
        }
    },
};

angular.module("limit").component(LimitInfo.selector, LimitInfo);
